<template>

  <div class="searchFilters">

    <div class="search_form_wrapper">

      <div class="position-sticky fixed-top bg-white pt-md-0">

        <!-- <div class="p-0 mb-0 larger d-block d-lg-none text-center" role="alert">
          <h3><svg class="icon icon-info"><use xlink:href="/assets/svg/symbol-defs.svg#icon-info"></use></svg>&nbsp;<strong> {{ totalNumCars }}</strong> Matches</h3>
        </div> -->

        <div class="d-lg-none">
          <SearchCrumbs></SearchCrumbs>
        </div>

        <div class="d-block d-lg-none">

          <div class="row no-gutters mb-2">

            <div class="col-8 pr-2">
              <select name="mobileSort" class="form-control mt-0 mb-0 float-right" @change="mobileSort">
                <option selected>-- Sort By --</option>
                <option value="year|ASC" data-sortBy="year" data-sortType="asc" :selected="isSelectedSort('year', 'asc')">Sort by Year: Old to New</option>
                <option value="year|DESC" data-sortBy="year" data-sortType="desc" :selected="isSelectedSort('year', 'desc')">Sort by Year: New to Old</option>
                <option value="make|ASC" data-sortBy="make" data-sortType="asc" :selected="isSelectedSort('make', 'asc')">Sort by Make: A-Z</option>
                <option value="make|DESC" data-sortBy="make" data-sortType="desc" :selected="isSelectedSort('make', 'desc')">Sort by Make: Z-A</option>
                <option value="model|ASC" data-sortBy="model" data-sortType="asc" :selected="isSelectedSort('model', 'asc')">Sort by Model: A-Z</option>
                <option value="model|DESC" data-sortBy="model" data-sortType="desc" :selected="isSelectedSort('model', 'desc')">Sort by Model: Z-A</option>
                <option value="list|ASC" data-sortBy="list" data-sortType="asc" :selected="isSelectedSort('list', 'asc')">Sort by Price: Low to High</option>
                <option value="list|DESC" data-sortBy="list" data-sortType="desc" :selected="isSelectedSort('list', 'desc')">Sort by Price: High to Low</option>
                <option value="mileage|ASC" data-sortBy="mileage" data-sortType="asc" :selected="isSelectedSort('mileage', 'asc')">Sort by Mileage: Low to High</option>
                <option value="mileage|DESC" data-sortBy="mileage" data-sortType="desc" :selected="isSelectedSort('mileage', 'desc')">Sort by Mileage: High to Low</option>
                <option value="fuel_economy_city_high|ASC" data-sortBy="fuel_economy_city_high" data-sortType="asc" :selected="isSelectedSort('fuel_economy_city_high', 'asc')">Sort by MPG: Low to High</option>
                <option value="fuel_economy_city_high|DESC" data-sortBy="fuel_economy_city_high" data-sortType="desc" :selected="isSelectedSort('fuel_economy_city_high', 'desc')">Sort by MPG: High to Low</option>
              </select>
            </div>

            <div class="col-4">
              <!-- <a href="#" class="btn btn-primary btn-block close-mobile-vehicle-search">Done</a> -->
              <a href="#" class="btn btn-primary btn-block close-mobile-vehicle-search" v-b-toggle.collapse-1><svg class="icon icon-close" style="top: 0px;"><use xlink:href="/assets/svg/symbol-defs.svg#icon-close"></use></svg>Close</a>
            </div>

          </div>

        </div>

      </div>

      <form class="mb-0 vehicle_search_form" action="/" method="get" @submit.prevent="" @change="searchFiltersChanged" autocomplete="off" id="vehicle_search_form">

        <fieldset>

          <div class="row">

            <div class="col-12 stock_type">

                <div class="row">

                  <div class="col-xl-6 pr-xl-1 mb-2">

                    <a
                      href="#"
                      class="btn btn-block"
                      :class="{ 'btn-primary': this.$route.name === 'new', 'btn-outline-primary': this.$route.name !== 'new' }"
                      rel="nofollow"
                      role="button"
                      @click.prevent="stockTypeChange('new')"
                    >
                      &nbsp;New
                    </a>

                  </div>

                  <div class="col-xl-6 pl-xl-1 mb-2">

                    <a
                      href="#"
                      class="btn btn-block"
                      :class="{ 'btn-primary': this.$route.name === 'used', 'btn-outline-primary  ': this.$route.name !== 'used' }"
                      rel="nofollow"
                      role="button"
                      @click.prevent="stockTypeChange('used')"
                    >
                      &nbsp;Pre-Owned
                    </a>

                  </div>

              </div>

            </div>

            <div class="col-12">
              <p class="float-left grid-view pointer" @click="changeViewFormat('grid')" :class="{ active: isViewFormatActive('grid') }">
                <svg class="icon icon-grid_view" style="font-size: 1.5rem;"><use xlink:href="/assets/svg/symbol-defs.svg#icon-grid_view"></use></svg> <span class="d-inline-block pt-2">Grid View</span>
              </p>
              <p class="float-right list-view pointer" @click="changeViewFormat('list')" :class="{ active: isViewFormatActive('list') }"><svg class="icon icon-format_list_bulleted" style="font-size: 1.5rem;"><use xlink:href="/assets/svg/symbol-defs.svg#icon-format_list_bulleted"></use></svg><span class="d-inline-block pt-2">List View</span></p>
            </div>

            <div class="my-1 pl-2 py-2 ml-3 mr-3 bg-light d-block w-100 larger" v-if="stockType !== 'used'">
              <label for="in-transit" class="w-100 position-relative">
                <input id="in-transit" type="checkbox" name="status_group" v-model="searchFilters.status_group" value="In-Transit"> In-Transit <i class="fa-solid fa-circle mr-2 text-in-transit status-dot"></i>
              </label>
            </div>

            <div class="my-1 pl-2 py-2 ml-3 mr-3 bg-light d-block w-100 larger" v-if="stockType !== 'used'">
              <label for="in-stock" class="w-100 position-relative">
                <input id="in-stock" type="checkbox" name="status_group" v-model="searchFilters.status_group" value="In-Stock"> In-Stock <i class="fa-solid fa-circle mr-2 text-in-stock status-dot"></i>
              </label>
            </div>

            <div class="my-1 pl-2 py-2 ml-3 mr-3 bg-light d-block w-100 larger">
              <label for="show_specials" class="w-100 position-relative">
                <input id="show_specials" type="checkbox" name="show_specials" v-model="searchFilters.show_specials" true-value="1" false-value=""> Specials <i class="fa-solid fa-circle mr-2 text-special status-dot"></i>
              </label>
            </div>

            <div v-if="stockType === 'used' || stockType === 'all'" class="my-1 pl-2 py-2 ml-3 mr-3 bg-light d-block w-100 larger">
              <label for="certified" class="w-100 position-relative">
                <input id="certified" type="checkbox" name="certified" v-model="searchFilters.certified"> Certified <i class="fa-solid fa-circle mr-2 text-certified status-dot"></i>
              </label>
            </div>

            <div class="my-1 pl-2 py-2 ml-3 mr-3 bg-light d-block w-100 larger">
              <label for="fresh" class="w-100 position-relative">
                <input id="fresh" type="checkbox" name="fresh" v-model="searchFilters.fresh" true-value="1" false-value=""> Fresh on the Lot <i class="fa-solid fa-circle mr-2 text-fresh status-dot"></i>
              </label>
            </div>

            <div class="col-12 my-2 keyword_search">

              <label class="sr-only" for="keyword">Keyword</label>
              <div class="input-group mb-1">
                <input type="text" class="form-control" placeholder="Keyword" name="keyword" :value="searchFilters.keyword">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <a href="#" @click.prevent="searchFiltersChanged">
                      <svg class="icon icon-search"><use xlink:href="/assets/svg/symbol-defs.svg#icon-search"></use></svg>
                    </a>
                  </div>
                </div>
              </div>

            </div>

            <div class="col-12">

              <label for="year" class="large bg-dark text-white w-100 mb-1">
                <strong>
                  <a class="d-block text-white p-2 float-left" @click="$emit('update:yearsVisible', !yearsVisible)" role="button" :aria-expanded="yearsVisible" aria-controls="collapseYears">
                    Years <svg :class="'icon ' + yearsFilterIcon"><use :xlink:href="'/assets/svg/symbol-defs.svg#' + yearsFilterIcon"></use></svg>
                  </a>
                </strong>
                <a v-if="this.searchFilters.year.length > 0" href="#" @click.prevent="clearCheckboxGroup($event)" data-checkboxid="year" class="d-block text-white p-2 float-right">[x] clear</a>
              </label>

              <br>

              <b-collapse visible id="collapseYears" class="" v-model="yearsVisible">
                <div>
                  <div v-if="allYears">
                    <div v-for="yearObj in allYears" :key="yearObj.year" >
                      <label class="d-block large mb-2" :for="yearObj.year">
                      <input type="checkbox"
                        aria-label="Checkbox for following text input"
                        name="year"
                        v-model="searchFilters.year"
                        :value="yearObj.year"
                        :id="yearObj.year"
                        class="required ml-1 makeCheckbox"> {{ yearObj.year }} ({{ yearObj.count }})
                      </label>
                    </div>
                  </div>
                </div>
              </b-collapse>

            </div>

            <div class="col-12">

              <label for="body_type" class="large bg-dark text-white w-100 mb-1">
                <strong>
                  <a class="d-block text-white p-2 float-left" @click="$emit('update:bodyTypeVisible', !bodyTypeVisible)" role="button" :aria-expanded="bodyTypeVisible" aria-controls="collapseBodyType">
                    Body Type <svg :class="'icon ' + bodyTypeFilterIcon"><use :xlink:href="'/assets/svg/symbol-defs.svg#' + bodyTypeFilterIcon"></use></svg>
                  </a>
                </strong>
                <a v-if="this.searchFilters.body_type.length > 0" href="#" @click.prevent="clearCheckboxGroup($event)" data-checkboxid="body_type" class="d-block text-white p-2 float-right">[x] clear</a>
              </label>

              <br>

              <b-collapse id="collapseBodyType" class="" v-model="bodyTypeVisible">

                <div v-if="allBodyTypes">
                  <div v-for="(bodyTypeCount, bodyTypeName) in allBodyTypes" :key="bodyTypeName" >
                    <label class="d-block large mb-2" v-if="bodyTypeName !== 'null'" :for="bodyTypeName">
                    <input type="checkbox"
                      aria-label="Checkbox for following text input"
                      name="body_type"
                      v-model="searchFilters.body_type"
                      :value="bodyTypeName"
                      :id="bodyTypeName"
                      class="required ml-1 bodyTypeCheckbox"> {{ bodyTypeName }} ({{ bodyTypeCount }})
                    </label>
                  </div>
                </div>

              </b-collapse>

            </div>

            <div class="col-12">

              <label for="make" class="large bg-dark text-white w-100 mb-1">
                <strong>
                  <a class="d-block text-white p-2 float-left" @click="$emit('update:makeVisible', !makeVisible)" role="button" :aria-expanded="makeVisible" aria-controls="collapseMakes">
                    Makes <svg :class="'icon ' + makeFilterIcon"><use :xlink:href="'/assets/svg/symbol-defs.svg#' + makeFilterIcon"></use></svg>
                  </a>
                </strong>
                <a v-if="this.searchFilters.make.length > 0" href="#" @click.prevent="clearCheckboxGroup($event)" data-checkboxid="make" class="d-block text-white p-2 float-right">[x] clear</a>
              </label>

              <br>

              <b-collapse id="collapseMakes" class="" v-model="makeVisible">
                <div>
                  <div v-if="allMakes">
                    <div v-for="(makeCount, makeName) in allMakes" :key="makeName" >
                      <label class="d-block large mb-2">
                      <input type="checkbox"
                        aria-label="Checkbox for following text input"
                        name="make"
                        v-model="searchFilters.make"
                        :value="makeName"
                        class="required ml-1 makeCheckbox"> {{ makeName }} ({{ makeCount }})
                      </label>
                    </div>
                  </div>
                </div>
              </b-collapse>

            </div>

            <div class="col-12">

              <label for="model" class="large bg-dark text-white w-100 mb-1">
                <strong>
                  <a class="d-block text-white p-2 float-left" @click="$emit('update:modelVisible', !modelVisible)" role="button" :aria-expanded="modelVisible" aria-controls="collapseModels">
                    Models <svg :class="'icon ' + modelFilterIcon"><use :xlink:href="'/assets/svg/symbol-defs.svg#' + modelFilterIcon"></use></svg>
                  </a>
                </strong>
                <a v-if="this.searchFilters.model.length > 0" href="#" @click.prevent="clearCheckboxGroup($event)" data-checkboxid="model" class="d-block text-white p-2 float-right">[x] clear</a>
              </label>

              <br>

              <b-collapse id="collapseModels" class="" v-model="modelVisible">

                <div v-if="allModels">
                  <div v-for="(modelCount, modelName) in allModels" :key="modelName" >
                    <label class="d-block large mb-2" v-if="modelName !== ''">
                    <input type="checkbox"
                      aria-label="Checkbox for following text input"
                      name="model"
                      v-model="searchFilters.model"
                      :value="modelName"
                      class="required ml-1 modelCheckbox"> {{ modelName }} ({{ modelCount }})
                    </label>
                  </div>
                </div>

              </b-collapse>

            </div>

            <div class="col-12">

              <label for="price" class="large bg-dark text-white w-100 mb-1">
                <strong>
                  <a class="d-block text-white p-2 float-left" @click="$emit('update:priceVisible', !priceVisible)" role="button" :aria-expanded="priceVisible" aria-controls="collapsePrice">
                    Price <svg :class="'icon ' + priceFilterIcon"><use :xlink:href="'/assets/svg/symbol-defs.svg#' + priceFilterIcon"></use></svg>
                  </a>
                </strong>
                <a v-if="typeof(searchFilters.endPrice) !== 'undefined' || typeof(searchFilters.startPrice) !== 'undefined'" href="#" @click.prevent="clearCheckboxGroup($event)" data-checkboxid="price" class="d-block text-white p-2 float-right">[x] clear</a>
              </label>

              <br />

              <b-collapse visible id="collapsePrice" class="" v-model="priceVisible">

                <div>

                  <div class="col-12">

                    <label for="priceRangeStart"><strong>Minimum</strong> Price: <transition name="fade"><span class="text-danger" v-if="showPriceRangeError"><sup>*</sup></span></transition></label>

                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="priceRangeStart">$</span>
                      </div>
                      <input type="number" class="form-control" min="0" :step="priceRangeStep" :max="max_price" v-model.number="localPriceStart" aria-label="priceRangeStart" aria-describedby="priceRangeStart" />
                    </div>

                    <div class="d-block mx-auto">
                      <input
                        type="range"
                        class="custom-range"
                        id="priceRangeStart"
                        name="priceRangeStart"
                        min="0"
                        :max="max_price"
                        :step="priceRangeStep"
                        v-model.number="localPriceStart"
                      >

                      <hr />

                    </div>

                  </div>

                  <div class="col-12">

                    <label for="priceRangeEnd"><strong>Maximum</strong> Price: <transition name="fade"><span class="text-danger" v-if="showPriceRangeError"><sup>*</sup></span></transition></label>

                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="priceRangeEnd">$</span>
                      </div>
                      <input type="number" class="form-control" min="1000" :step="priceRangeStep" :max="max_price" v-model.number="localPriceEnd" aria-label="priceRangeEnd" aria-describedby="priceRangeEnd" />
                    </div>

                    <div class="d-block mx-auto">
                      <input
                        type="range"
                        class="custom-range"
                        id="priceRangeEnd"
                        name="priceRangeEnd"
                        min="1000"
                        :max="max_price"
                        :step="priceRangeStep"
                        v-model.number="localPriceEnd"
                      >

                    </div>

                  </div>

                  <div class="col-12">
                    <transition name="fade"><p class="text-danger mb-0" v-if="showPriceRangeError"><sup>*</sup>Lower min price or raise max price.</p></transition>
                  </div>

                </div>

              </b-collapse>

            </div>

          </div>

        </fieldset>

      </form>

    </div>

    <hr />

    <p class="text-muted small text-center my-3">Inventory Updated<br />{{ $store.state.requestDate }}</p>

  </div>
</template>

<script>

// import vuex
import { mapState, mapGetters } from 'vuex'

import SearchCrumbs from '@/components/SearchCrumbs.vue'

// import bootstrap-vue components
import { VBToggle, BCollapse } from 'bootstrap-vue'

export default {
  name: 'searchFilters',
  props: {
    makeVisible: Boolean,
    modelVisible: Boolean,
    bodyTypeVisible: Boolean,
    yearsVisible: Boolean,
    priceVisible: Boolean,
    queryPopulated: Boolean,
    max_price: Number
  },
  data () {
    return {
      show_specials: this.$store.state.searchFilters.show_specials,
      localPriceStart: 0,
      localPriceEnd: 100000,
      priceRangeStep: 1000
    }
  },
  components: {
    BCollapse,
    SearchCrumbs
  },
  directives: {
    'b-toggle': VBToggle,
    'b-collapse': BCollapse
  },
  beforeMount () {
    // if price filter is already populated, use it. Else use the default price filter.
    if (typeof (this.searchFilters.startPrice) !== 'undefined') {
      this.localPriceStart = this.searchFilters.startPrice
    }
    if (typeof (this.searchFilters.endPrice) !== 'undefined') {
      this.localPriceEnd = this.searchFilters.endPrice
    } else {
      this.localPriceEnd = this.max_price
    }
  },
  watch: {
    searchFilters: function (obj) {
      if (typeof (obj.startPrice) === 'undefined') {
        this.localPriceStart = 0
      }
      if (typeof (obj.endPrice) === 'undefined') {
        this.localPriceEnd = this.max_price
      }
    },
    localPriceStart: function (val) {
      if (val === 0) {
        this.searchFilters.startPrice = undefined
      } else {
        this.searchFilters.startPrice = val
      }
    },
    localPriceEnd: function (val) {
      if (val === this.max_price) {
        this.searchFilters.endPrice = undefined
      } else {
        this.searchFilters.endPrice = val
      }
    }
  },
  computed: {
    ...mapGetters(['allMakes', 'allModels', 'allBodyTypes', 'allYears']),
    ...mapState(['searchFilters', 'stockType', 'totalNumCars', 'displayResults', 'viewFormat']),
    /**
     * Control the plus/minus icon for make dropdown
     */
    makeFilterIcon: function () {
      if (this.makeVisible === true) {
        return 'icon-minus-circle'
      } else {
        return 'icon-plus-circle'
      }
    },
    /**
     * Control the plus/minus icon for model dropdown
     */
    modelFilterIcon: function () {
      if (this.modelVisible === true) {
        return 'icon-minus-circle'
      } else {
        return 'icon-plus-circle'
      }
    },
    /**
     * Control the plus/minus icon for body_type dropdown
     */
    bodyTypeFilterIcon: function () {
      if (this.bodyTypeVisible === true) {
        return 'icon-minus-circle'
      } else {
        return 'icon-plus-circle'
      }
    },
    /**
     * Control the plus/minus icon for years dropdown
     */
    yearsFilterIcon: function () {
      if (this.yearsVisible === true) {
        return 'icon-minus-circle'
      } else {
        return 'icon-plus-circle'
      }
    },
    showPriceRangeError: function () {
      if (this.searchFilters.endPrice < this.searchFilters.startPrice || this.searchFilters.startPrice > this.searchFilters.endPrice) {
        return true
      } else {
        return false
      }
    },
    priceFilterIcon: function () {
      if (this.priceVisible === true) {
        return 'icon-minus-circle'
      } else {
        return 'icon-plus-circle'
      }
    }
  },
  methods: {
    /**
     * Router link - programmatically
     */
    stockTypeChange (stockType) {
      // store stockType
      this.$store.dispatch('storeStockType', stockType)

      // reset searchFilters
      this.$root.resetSearchFilters()

      // push to router
      this.$root.pushToRouter(stockType, [])
    },
    /**
     * Actions to take when our searchFilter form gets clicked
     */
    searchFiltersChanged (el) {
      // get our element info
      const elChecked = el.target.checked
      const elName = el.target.name
      const elValue = el.target.value

      // console.log(elChecked, 'elChecked')
      // console.log(elName, 'elName')
      // console.log(elValue, 'elValue')

      // unchecking make checkbox also removes all searchFilters.model for the make
      if (elName === 'make' && elChecked === false) {
        // get all models for this make
        this.$root._.filter(this.$store.state.cars, car => {
          if (car.make === elValue) {
            this.searchFilters.model.pop(car.model)
          }
        })
      }

      // if model is clicked before make, auto check make for that model
      if (el.srcElement.name === 'model') {
        // make sure the make is selected too
        this.$root._.filter(this.$store.state.cars, o => {
          if (o.model === el.srcElement.value) {
            if (!this.$root._.includes(this.searchFilters.make, o.make)) {
              this.searchFilters.make.push(o.make)
            }
          }
        })
      }

      // hide models dropdown if no makes are selected
      /* if (this.$root._.isEmpty(this.searchFilters.make)) {
        if (this.modelVisible === true) {
          this.$emit('update:modelVisible', false)
        }
      } */

      // show specials?
      if (this.searchFilters.show_specials === '') {
        this.searchFilters.show_specials = undefined
      }

      // certified
      if (this.searchFilters.certified === false) {
        this.searchFilters.certified = undefined
      }

      // fresh on the lot
      if (this.searchFilters.fresh === '') {
        this.searchFilters.fresh = undefined
      }

      // in-transit / in-stock
      // if (this.searchFilters.status.length === 0) {
      //   this.searchFilters.status = undefined
      // }

      // keyword search
      if (el.srcElement.name === 'keyword') {
        if (elValue !== '') {
          // assign keyword value
          this.searchFilters.keyword = elValue
        } else {
          this.searchFilters.keyword = undefined
        }
      }

      // remove 'page=1' from the url
      this.searchFilters.page = undefined

      // push to router
      this.$root.pushToRouter(name, this.searchFilters)

      // show model checkboxes
      if ((elName === 'make' || elName === 'body_type') && elChecked === true && this.modelVisible === false) {
        this.$emit('update:modelVisible', true)
      }
    },
    /**
     * Clear checkbox group
     * @param $event - click event info
     */
    clearCheckboxGroup: function ($event) {
      // get checkbox id so we know what to clear
      var filterId = $event.target.dataset.checkboxid

      // clear this item from our searchFilters object
      if (typeof (this.searchFilters[filterId]) === 'object') {
        this.searchFilters[filterId] = []
      }

      if (filterId === 'price') {
        this.searchFilters.startPrice = undefined
        this.searchFilters.endPrice = undefined
        this.localPriceStart = 0
        this.localPriceEnd = this.max_price
      }

      if (filterId === 'year') {
        this.searchFilters.year = []
      }

      // if clearing 'make' checkboxes, clear model checkboxes as well
      /* if (filterId === 'make') {
        this.searchFilters.model = []
        this.$emit('update:modelVisible', false)
      } */

      // reset our pagination to 1 (undefined)
      this.searchFilters.page = undefined

      // save our searchFilters to store.state
      this.$store.dispatch('storeSearchFilters', this.searchFilters, 'SearchFilters:clearCheckboxGroup()')

      // push our new url to router
      this.$root.pushToRouter(this.$route.name, this.searchFilters)
    },
    /**
     * Custom router link
     */
    routerLink (resetSearchFilters, linkObj) {
      var searchFilters = {}
      if (resetSearchFilters === true) {
        searchFilters = this.$root.resetSearchFilters()
      }

      searchFilters = { ...this.searchFilters, ...linkObj }

      // get route name (new or used)
      const name = this.$route.name

      this.$store.dispatch('storeSearchFilters', searchFilters)

      // push to router
      this.$root.pushToRouter(name, searchFilters)
    },
    mobileSort (el) {
      this.searchFilters.sortType = el.target.selectedOptions[0].dataset.sorttype
      this.searchFilters.sortBy = el.target.selectedOptions[0].dataset.sortby

      // get route name (new or used)
      const name = this.$route.name

      // push to router
      this.$root.pushToRouter(name, this.searchFilters)
    },
    isSelectedSort (sortBy, sortType) {
      if (sortBy === this.searchFilters.sortBy && sortType === this.searchFilters.sortType) {
        return true
      } else {
        return false
      }
    },
    changeViewFormat (viewFormat) {
      if (viewFormat !== this.viewFormat) {
        this.$store.dispatch('storeViewFormat', viewFormat)
        this.searchFilters.viewFormat = viewFormat

        // get route name (new or used)
        const name = this.$route.name

        // push to router
        this.$root.pushToRouter(name, this.searchFilters)
      }
    },
    isViewFormatActive (viewFormat) {
      if (this.viewFormat === viewFormat) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  #vehicle-search-filters {
    line-height: 27px!important;
  }
  .mm-menu, .mm-panel, .mm-panels {
    background: none!important;
  }
  .btn-primary {
    color: white!important;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .status-dot {
    position: absolute;
    right: 0;
    top: 7px;
    font-size: 80%;
  }
</style>
